import { render, staticRenderFns } from "./VisitRecords.vue?vue&type=template&id=77b02b69&scoped=true&"
import script from "./VisitRecords.vue?vue&type=script&lang=js&"
export * from "./VisitRecords.vue?vue&type=script&lang=js&"
import style0 from "./VisitRecords.vue?vue&type=style&index=0&id=77b02b69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b02b69",
  null
  
)

export default component.exports